// @ts-nocheck
import * as React from "react";

const List: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M20.06 16c.52 0 .94.42.94.94v.12c0 .52-.42.94-.94.94H7.94a.94.94 0 01-.94-.94v-.12c0-.52.42-.94.94-.94h12.12zm-15.353.293a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414zM20.06 11c.52 0 .94.42.94.94v.12c0 .52-.42.94-.94.94H7.94a.94.94 0 01-.94-.94v-.12c0-.52.42-.94.94-.94h12.12zm-15.353.293a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414zM20.06 6c.52 0 .94.42.94.94v.12c0 .52-.42.94-.94.94H7.94A.94.94 0 017 7.06v-.12c0-.52.42-.94.94-.94h12.12zm-15.353.293a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(List);
